import { render, staticRenderFns } from "./hzdw.vue?vue&type=template&id=dec4051c&scoped=true"
import script from "./hzdw.vue?vue&type=script&lang=js"
export * from "./hzdw.vue?vue&type=script&lang=js"
import style0 from "./hzdw.vue?vue&type=style&index=0&id=dec4051c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec4051c",
  null
  
)

export default component.exports